/*!
 * CIC — Product Page Boost
 * Sticky Add-to-Cart bar that appears on scroll
 */
(function () {
  'use strict';

  function initStickyATC() {
    var bar = document.querySelector('.cic-sticky-atc');
    var buyBtn = document.querySelector('.product-form__submit');
    var stickyBtn = document.querySelector('.cic-sticky-atc__btn');
    var closeBtn = document.querySelector('.cic-sticky-atc__close');

    if (!bar || !buyBtn) return;

    var dismissed = false;
    var ticking = false;

    function checkScroll() {
      if (dismissed) return;
      var rect = buyBtn.getBoundingClientRect();
      // Show bar when buy button scrolls out of view (below fold)
      var buyBtnBelow = rect.bottom < 0;
      if (buyBtnBelow) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          checkScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Sticky button submits the real form
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        // Find and submit the add-to-cart form
        var form = document.querySelector('form[action="/cart/add"]') ||
                   document.querySelector('[data-type="add-to-cart-form"]') ||
                   document.querySelector('.product-form__cart-submit')?.closest('form');
        if (form) {
          // Trigger click on original buy button to maintain Dawn's cart logic
          if (buyBtn) {
            buyBtn.click();
          } else {
            form.submit();
          }
          // Flash feedback
          var orig = stickyBtn.textContent;
          stickyBtn.textContent = '✓ Added!';
          setTimeout(function () { stickyBtn.textContent = orig; }, 1800);
        }
      });
    }

    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dismissed = true;
        bar.classList.remove('is-visible');
      });
    }
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }
})();
